module.exports = __webpack_public_path__ + "img/polish.8723aec.svg";